import WebFont from 'webfontloader';

export const getBunnyCustomFontLoader = ({ font }: { font: string }) => ({
  families: [font],
  urls: [`https://fonts.bunny.net/css?family=${font}:400,700`],
});

export const webFontLoader = ({
  font,
  activeCallback,
}: {
  activeCallback?: () => void;
  font: string;
}) => {
  const bunnyFontLoader = getBunnyCustomFontLoader({ font });

  WebFont.load({
    custom: bunnyFontLoader,
    active: activeCallback || undefined,
  });
};
